import * as React from 'react';
import { Flex, Box } from 'grid-styled';
import { createFragmentContainer, graphql } from 'react-relay';
/* Components */
import EventsDropDown from './EventsDropDown';
/* Styles */
import './ShopWithCeoProfile.scss';
import { ShopWithCeoProfile_user } from './__generated__/ShopWithCeoProfile_user.graphql';

import { urlDefaultProfile } from '../../../../server/utils/urlConstants';
import { getImageUrl } from '../../../utils/helpers';
import { myStoryDefaultMessage } from '../../contentConstants';

interface ProfileType {
  readonly image: string | null;
  readonly summary: string | null;
  readonly city: string | null;
  readonly state: string | null;
  readonly zip: string | null;
}

interface ShopWithCeoProfileProps {
  ceoId: string | null;
  firstName: string | null;
  lastName: string | null;
  containerWidth: number;
  handleSelectedEvent: (selectedEvent: string) => void;
  handleCartHotSwap: () => void;
  handleRouteChange: (path: string) => void;
  handleAuthentication: () => void;
  user: ShopWithCeoProfile_user;
  profile: ProfileType | null;
  cancelShoppingWithCeo: () => void;
}

interface ShopWithCeoProfileState {}

class ShopWithCeoProfile extends React.Component<
  ShopWithCeoProfileProps,
  ShopWithCeoProfileState
> {
  render() {
    const {
      user,
      ceoId,
      firstName,
      lastName,
      handleSelectedEvent,
      containerWidth,
      handleRouteChange,
      handleAuthentication,
      handleCartHotSwap,
      profile,
    } = this.props;
    if (!profile) return <div />;
    const { summary, city, state, image } = profile;
    const profileImage = image
      ? getImageUrl(image, 'thumb')
      : `${urlDefaultProfile}default_profile.svg`;
    const profileSummary = summary || myStoryDefaultMessage;
    const profileImageStyle = {
      background: `url("${profileImage}") center center / cover no-repeat`,
    };
    return (
      <Flex column className="ShopWithCeoProfile">
        <Box className="ShopWithCeoProfileImageContainer">
          <div className="media-photo media-round">
            <div style={profileImageStyle} className="ShopWithCeoProfile_img" />
          </div>
        </Box>
        <Box className="ShopWithCeoProfile_name">
          {firstName} {lastName}
        </Box>
        {city && (
          <Box className="ShopWithCeoProfile_location">
            {city}, {state}
          </Box>
        )}
        <Box>
          <EventsDropDown
            user={user}
            ceoId={ceoId}
            firstName={firstName}
            containerWidth={containerWidth}
            handleCartHotSwap={handleCartHotSwap}
            handleRouteChange={handleRouteChange}
            handleSelectedEvent={handleSelectedEvent}
            handleAuthentication={handleAuthentication}
          />
        </Box>
        <Box className="ShopWithCeoProfile_description">{profileSummary}</Box>
      </Flex>
    );
  }
}

export default createFragmentContainer(ShopWithCeoProfile, {
  user: graphql`
    fragment ShopWithCeoProfile_user on User {
      ...EventsDropDown_user
      shoppingWithCeoUser {
        userId
        firstName
      }
    }
  `,
});
